document.addEventListener('change', (event) => {
    if (event.target.closest('.polymorphic_select')) {
        const formElement = event.target.closest('.element')

        updateSelectPolymorphic(formElement)
    }
})

const updateSelectPolymorphic = (formElement) => {
    if (formElement) {
        const selectPolymorphic = formElement.querySelector('.polymorphic_select'),
            inputPolymorphicType = formElement.querySelector('.polymorphic_type')
            
        if (selectPolymorphic && inputPolymorphicType) {
            const selectedOption = selectPolymorphic.options[selectPolymorphic.selectedIndex]

            if (selectedOption) {
                inputPolymorphicType.value = selectedOption.dataset.type
            }
        }
    }
}